module.exports = __webpack_public_path__ + "src/shared-components/icons/question-mark.89e98dc075e4227061423adaf05eea6b.svg";